module.exports = __webpack_public_path__ + "img/logo_small2.6e473487.png";